import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const getHistoryOrdersStatus = createSelector(historyOrdersState, (historyOrders) => ({
    isDownloading: historyOrders?.isDownloading,
    hasSucceeded: historyOrders?.hasSucceeded,
    hasFailed: historyOrders?.hasFailed,
}));
